import { Modal, ModalOverlayProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type ModalFormOverlayProps = ModalOverlayProps;

export const createModalFormOverlay = () => {
	const ModalFormOverlay = forwardRef<HTMLDivElement, ModalFormOverlayProps>(
		({ className, children, ...props }, ref) => (
			<Modal.Overlay
				ref={ref}
				className={clsx('modal-form-overlay', className)}
				{...props}
			>
				{children}
			</Modal.Overlay>
		),
	);

	return ModalFormOverlay;
};
